export default "__VITE_ASSET__BplKE9Dv__"